import { Feature } from '@agm/core/services/google-maps-types';
import { Component, Directive, ElementRef, Input, AfterViewInit, ViewContainerRef, TemplateRef } from '@angular/core';
import { FeatureFlagService } from '../feature-flag.service';

@Directive({
    selector: '[showColumn]'
})
export class ShowColumnDirective {
    @Input() set showColumn(condition: boolean) {
        if (condition) {
            this.viewContainer.clear()
        }
    }

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef) {
    }
}